import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../../../../config/AuthContext";
import { Table, Tag, Card, Button, Typography, Space, Spin, Tooltip, Avatar } from "antd";
import { ColumnsType } from "antd/es/table";
import { BiRefresh, BiTrophy } from "react-icons/bi";
import { TrophyOutlined, FireOutlined, StarFilled, CrownOutlined } from '@ant-design/icons';
import AppSider from "../../components/AppSider";
import { Content } from "antd/es/layout/layout";
import { GetRankingsUsuariId } from "../../../../dao/jutge/GetRankingsUsuariId";

const { Title, Text } = Typography;

export const Ranking: React.FC = () => {
    const { isLoggedIn, userId, setBreadCrumb } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [rankings, setRankings] = useState<any[]>([]);

    useEffect(() => {
        if (isLoggedIn) {
            setBreadCrumb([
                { nom: 'Home', nav: '/home' },
                { nom: 'database', nav: '/database' },
                { nom: 'ranking', nav: '/database/ranking' }
            ], true);
            checkDades();
        }
    }, [isLoggedIn]);

    const checkDades = async () => {
        setLoading(true);
        try {
            const data = await GetRankingsUsuariId(userId);
            setRankings(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error("Error al carregar ranking:", e);
        } finally {
            setLoading(false);
        }
    };

    const columns: ColumnsType<any> = [
        {
            title: "Posició",
            dataIndex: "posicio",
            key: "posicio",
            width: 90,
            align: "center",
            render: (pos, record, index) => {
                const p = pos ?? (index + 1);
                if (p === 1) return <CrownOutlined style={{ color: '#ffd700', fontSize: 22 }} />;
                if (p === 2) return <TrophyOutlined style={{ color: '#c0c0c0', fontSize: 20 }} />;
                if (p === 3) return <TrophyOutlined style={{ color: '#cd7f32', fontSize: 18 }} />;
                return <Tag style={{ borderRadius: 12, fontWeight: 700 }}>#{p}</Tag>;
            }
        },
        {
            title: "Alumne",
            dataIndex: "nom",
            key: "nom",
            render: (text, record) => (
                <Space>
                    <Avatar style={{ backgroundColor: '#1890ff' }}>
                        {text ? text.charAt(0).toUpperCase() : 'U'}
                    </Avatar>
                    <Text strong>{text} {record.cognoms || ''}</Text>
                </Space>
            )
        },
        {
            title: "Exercicis Resolts",
            dataIndex: "resolts",
            key: "resolts",
            align: "center",
            render: (val) => <Tag color="green">{val ?? 0} resolts</Tag>
        },
        {
            title: "Punts de Recompensa",
            dataIndex: "punts",
            key: "punts",
            align: "center",
            render: (val) => (
                <Tag color="gold" style={{ fontSize: 13, fontWeight: 700, padding: '2px 8px' }}>
                    🪙 {val ?? 0} pts
                </Tag>
            )
        }
    ];

    return (
        <div style={{ display: 'flex', width: '100%', minHeight: '100vh', background: '#f8f9fb' }}>
            <AppSider currentVal={5} />
            <Content style={{ padding: '24px', flex: 1 }}>
                <Card
                    bordered={false}
                    style={{
                        borderRadius: 16,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        background: '#fff'
                    }}
                >
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 20
                    }}>
                        <div>
                            <Title level={3} style={{ margin: 0, color: '#1f2937' }}>
                                🏆 Rànquing & Gamificació Base de Dades
                            </Title>
                            <Text type="secondary">
                                Puntuacions obtingudes per resolució d'exercicis en mode normal i mode desafiament.
                            </Text>
                        </div>

                        <Button
                            icon={<BiRefresh />}
                            onClick={checkDades}
                            loading={loading}
                        >
                            Refrescar
                        </Button>
                    </div>

                    <Table
                        columns={columns}
                        dataSource={rankings}
                        rowKey={(r, idx) => r.id || idx}
                        loading={loading}
                        pagination={{ pageSize: 15 }}
                        bordered={false}
                    />
                </Card>
            </Content>
        </div>
    );
};

export default Ranking;
